import Vue from 'vue'
import { loadDingTalkSdk } from './dingtalk-sdk'

export const dingTalkNavigation = Vue.observable({ nativeHeader: false })
let revision = 0

// Only confirmed mobile containers take over the web header; desktop keeps its navigation.
export function syncDingTalkNavigation(title, webMode) {
  const current = ++revision
  if (!webMode || !/DingTalk/i.test(navigator.userAgent)) {
    dingTalkNavigation.nativeHeader = false
    return
  }
  loadDingTalkSdk().then(dd => {
    if (current !== revision || !dd) return
    const mobile = dd.env && ['android', 'ios'].includes(String(dd.env.platform).toLowerCase())
    if (!mobile) dingTalkNavigation.nativeHeader = false
    const update = () => {
      if (current !== revision) return
      const navigation = dd.biz && dd.biz.navigation
      if (!navigation || typeof navigation.setTitle !== 'function') { dingTalkNavigation.nativeHeader = false; return }
      try {
        navigation.setTitle({
          title,
          onSuccess: () => { if (current === revision) dingTalkNavigation.nativeHeader = !!mobile },
          onFail: () => { if (current === revision) dingTalkNavigation.nativeHeader = false }
        })
      } catch (_) { if (current === revision) dingTalkNavigation.nativeHeader = false }
    }
    if (typeof dd.ready === 'function') dd.ready(update)
    else update()
  }).catch(() => { if (current === revision) dingTalkNavigation.nativeHeader = false })
}
